import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowManualEnrollmentRequest,
  WorkflowEnrollmentResponse,
  WorkflowEnrollmentFilterRequest
} from '../models/workflow-runtime.model';
import { PageResponse } from '../../../auth-pages/models/user.model';

@Injectable({ providedIn: 'root' })
export class WorkflowEnrollmentApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  manualEnrollGlobal(request: WorkflowManualEnrollmentRequest): Observable<WorkflowEnrollmentResponse> {
    return this.http.post<WorkflowEnrollmentResponse>(
      `${this.apiUrl}/workflow-enrollments/manual`, request
    );
  }

  manualEnroll(workflowId: number, request: WorkflowManualEnrollmentRequest): Observable<WorkflowEnrollmentResponse> {
    return this.http.post<WorkflowEnrollmentResponse>(
      `${this.apiUrl}/workflows/${workflowId}/enrollments/manual`, request
    );
  }

  getEnrollments(filters: WorkflowEnrollmentFilterRequest): Observable<any> {
    let params = new HttpParams();
    if (filters.businessId !== undefined) params = params.set('businessId', filters.businessId.toString());
    if (filters.workflowId)   params = params.set('workflowId', filters.workflowId.toString());
    if (filters.objectType)   params = params.set('objectType', filters.objectType);
    if (filters.objectId)     params = params.set('objectId', filters.objectId.toString());
    if (filters.status)       params = params.set('status', filters.status);
    if (filters.page !== undefined) params = params.set('page', filters.page.toString());
    if (filters.size !== undefined) params = params.set('size', filters.size.toString());
    return this.http.get<any>(`${this.apiUrl}/workflow-enrollments`, { params });
  }

  getById(id: number): Observable<WorkflowEnrollmentResponse> {
    return this.http.get<WorkflowEnrollmentResponse>(`${this.apiUrl}/workflow-enrollments/${id}`);
  }

  /**
   * Inscripciones de un workflow, filtradas y paginadas EN SERVIDOR.
   *
   * El endpoint ya aceptaba `objectType`, `objectId`, `status`, `page` y `size` y devolvía un
   * `PageResponse`, pero antes se llamaba sin ningún parámetro y el componente filtraba y contaba
   * en memoria: con muchas inscripciones se traía todo y la paginación no reflejaba el total real.
   */
  getByWorkflow(
    workflowId: number,
    filters: {
      objectType?: string;
      objectId?: number;
      status?: string;
      page?: number;
      size?: number;
    } = {}
  ): Observable<PageResponse<WorkflowEnrollmentResponse>> {
    let params = new HttpParams();
    if (filters.objectType) params = params.set('objectType', filters.objectType);
    if (filters.objectId !== undefined && filters.objectId !== null) {
      params = params.set('objectId', filters.objectId.toString());
    }
    if (filters.status) params = params.set('status', filters.status);
    if (filters.page !== undefined) params = params.set('page', filters.page.toString());
    if (filters.size !== undefined) params = params.set('size', filters.size.toString());
    return this.http.get<PageResponse<WorkflowEnrollmentResponse>>(
      `${this.apiUrl}/workflows/${workflowId}/enrollments`, { params }
    );
  }

  cancelEnrollment(enrollmentId: number, reason?: string): Observable<WorkflowEnrollmentResponse> {
    return this.http.post<WorkflowEnrollmentResponse>(
      `${this.apiUrl}/workflow-enrollments/${enrollmentId}/cancel`,
      { reason: reason || undefined }
    );
  }

  cancelEnrollmentByWorkflowObject(
    workflowId: number,
    payload: { objectType: string; objectId: number; reason?: string }
  ): Observable<WorkflowEnrollmentResponse> {
    return this.http.post<WorkflowEnrollmentResponse>(
      `${this.apiUrl}/workflows/${workflowId}/enrollments/cancel`,
      payload
    );
  }
}
